module.exports = function anonymous(it
) {
var out='<a class=\'js-'+(it.linkType)+'-link link\'>'+(it.link)+'</a>';return out;
}